<template>
  <transition name="modal">
    <div
      class="modal__mask"
      @click.stop.prevent="closeModal"
      v-show="showModal"
    >
      <div class="modal__wrapper">
        <div class="modal__box" @click="onModalClick">
          <div class="modal__close" v-if="showCloseButton">
            <img src="/img/close.png" @click.stop.prevent="closeModal" />
          </div>
          <div class="modal__body">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class Modal extends Vue {
  @Prop()
  showModal!: boolean

  @Prop({ default: false })
  showCloseButton!: boolean

  @Emit('close')
  closeModal(event: MouseEvent) {
    event.preventDefault()
  }

  onModalClick(event: MouseEvent) {
    event.stopPropagation()
  }
}
</script>

<style scoped>
.modal__mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  transition: opacity 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal__box {
  position: relative;
  width: 315px;
  margin: 0px auto;
  padding: 24px 16px;
  background-color: white;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
  text-align: center;
}

.modal__close {
  height: 24px;
  margin: 0 0 8px 0;
  text-align: right;
  position: absolute;
  top: 24px;
  right: 16px;
}

.modal__close img {
  width: 24px;
  height: 24px;
}


</style>

<!-- i18n style hacks -->
<style>
.-ru p.modal_text,
.-fr p.modal_text,
.-de p.modal_text,
.-es p.modal_text,
.-ms p.modal_text,
.-id p.modal_text,
.-pt-BR p.modal_text,
.-en p.modal_text 
{
  font-size: 12px;
  line-height: 14px;
  padding: 0 5px;
}

.-ru button.modal_button,
.-fr button.modal_button,
.-de button.modal_button,
.-es button.modal_button,
.-ms button.modal_button,
.-id button.modal_button,
.-pt-BR button.modal_button,
.-en button.modal_button 
{
  font-size: 10px;
  letter-spacing: inherit;
}
</style>